export const askAiStaticSuggestions = [
  "How much did we save last month using Reserved Instances, Committed Use Discounts, or Savings Plans?",
  "Which dev EC2 instances had zero network traffic in the last 14 days?",
  "List of EBS volumes that are currently detached?",
];
